export default __webpack_public_path__ + "static/forWhoImg1-bd60ede8275310275a2a6fb5392bf3e0.png";